// Pure route-authorization predicates, kept out of withAuthorization.js so they can be unit tested:
// that module pulls in App.js (Apollo, firebase) transitively, which cannot load under jest's node
// environment. Same split as accessControl.js beside it. Re-exported from withAuthorization.js, so
// existing import sites are unaffected.

// Deliberately NOT extended to CONTRACTOR. This predicate's only consumer is CarrierFTLBoard
// (/carrier/loads/ftl) — the FTL bidding board — and a contractor does not bid on freight; it is
// assigned work by the RLX carrier that subcontracted it. Contractor support in this branch is
// display-only.
//
// Excluding it here costs a contractor nothing on its own surfaces: Auth.js sends a contractor to
// /carrier/oms/myorders, which renders MyOrders directly with no withAuthorization wrapper, so it is
// not gated by this predicate. Nothing else imports it.
//
// CONTRACTOR is checked first because the roles are not exclusive: a contractor commonly also carries
// CARRIER, and it is the more specific label wherever the two disagree.
export const carrierAuthCondition = (user) => {
    if (user?.roles?.CONTRACTOR) return false;
    if (user?.roles?.CARRIER) return true;
    if (user?.roles?.TEAMMATE && user?.teammate?.roles?.operations) return true;

    return false;
};

export const shipperAuthCondition = (user) => {
    if (user?.roles?.SHIPPER) return true;
    if (user?.roles?.TEAMMATE && (user?.teammate?.roles?.operations || user?.teammate?.roles?.viewer)) return true;

    return false;
};
